// eslint-disable-next-line jira/filename-case
import React from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import ErrorBoundary from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import { useProject } from '@jira/navigation-apps__sidebar-common/src/controllers/project/index.tsx';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';
import { isProjectTypeAndEditionSupported } from './common/utils.tsx';

const AsyncRecommendPremiumToStandardModalComponent = lazyAfterPaint(
	() =>
		import(/* webpackChunkName:  "async-recommend-premium-to-standard-modal" */ './index.tsx').then(
			({ RecommendPremiumToStandardModalComponent }) => RecommendPremiumToStandardModalComponent,
		),
	{ entryFsSsrLiftImportToModule: true },
);
const AsyncRecommendPremiumToStandardModalWrapperWithCondition = (): React.ReactNode => {
	const { data: project } = useProject();
	const appEditions = useAppEditions();

	// Gate early to avoid loading the async modal for ineligible project/edition combinations.
	if (!isProjectTypeAndEditionSupported(appEditions, project?.type)) {
		return null;
	}
	return (
		<ErrorBoundary id="recommend-premium-to-standard-modal-async" packageName={PACKAGE_NAME}>
			<ReportErrors
				teamName={TEAM_NAME}
				id="recommend-premium-to-standard-modal-async"
				packageName={PACKAGE_NAME}
			>
				<AsyncRecommendPremiumToStandardModalComponent />
			</ReportErrors>
		</ErrorBoundary>
	);
};

const AsyncRecommendPremiumToStandardModalWrapperInternal = (): React.ReactNode => {
	return (
		<ErrorBoundary id="recommend-premium-to-standard-modal-async" packageName={PACKAGE_NAME}>
			<ReportErrors
				teamName={TEAM_NAME}
				id="recommend-premium-to-standard-modal-async"
				packageName={PACKAGE_NAME}
			>
				<AsyncRecommendPremiumToStandardModalComponent />
			</ReportErrors>
		</ErrorBoundary>
	);
};

export const AsyncRecommendPremiumToStandardModalWrapper: React.ComponentType<{}> = componentWithFG(
	'perf-async-recommend-premium-to-standard-modal',
	AsyncRecommendPremiumToStandardModalWrapperWithCondition,
	AsyncRecommendPremiumToStandardModalWrapperInternal,
);
